import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MainWrapper from '../MainWrapper';
import NotFound404 from '../../DefaultPage/404/index';
import LockScreen from '../../Account/LockScreen/index';
import LogIn from '../../Account/LogIn/index';
import LogInPhoto from '../../Account/LogInPhoto/index';
import Register from '../../Account/Register/index';
import RegisterPhoto from '../../Account/RegisterPhoto/index';
import ResetPassword from '../../Account/ResetPassword/index';
import ResetPasswordPhoto from '../../Account/ResetPasswordPhoto';
import WrappedRoutes from './WrappedRoutes';

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path={`${process.env.PUBLIC_URL}/`} component={LogIn} />
        <Route path={`${process.env.PUBLIC_URL}/404`} component={NotFound404} />
        <Route path={`${process.env.PUBLIC_URL}/lock_screen`} component={LockScreen} />
        <Route path={`${process.env.PUBLIC_URL}/log_in`} component={LogIn} />
        <Route path={`${process.env.PUBLIC_URL}/log_in_photo`} component={LogInPhoto} />
        <Route path={`${process.env.PUBLIC_URL}/register`} component={Register} />
        <Route path={`${process.env.PUBLIC_URL}/register_photo`} component={RegisterPhoto} />
        <Route path={`${process.env.PUBLIC_URL}/reset_password`} component={ResetPassword} />
        <Route path={`${process.env.PUBLIC_URL}/reset_password_photo`} component={ResetPasswordPhoto} />
        <Route path={`${process.env.PUBLIC_URL}/`} component={WrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;